// admin/src/Component/CookieConsent/Create.jconst requiredUrl = [required(), validateUrl];s
import React from 'react';
import {
    Create,
    TabbedForm,
    FormTab,
    TextInput,
    NumberInput,
    BooleanInput,
    required,
    regex,
    ReferenceInput,
    SelectInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { ColorInput } from 'react-admin-color-input';

const placeholderHintStyle = {
    background: '#f0f4ff',
    border: '1px solid #c5d0f0',
    borderRadius: '6px',
    padding: '10px 14px',
    marginBottom: '8px',
    fontSize: '13px',
    color: '#3a3a5c',
    lineHeight: '1.8',
};

const badgeStyle = {
    display: 'inline-block',
    background: '#3d5af1',
    color: '#fff',
    borderRadius: '4px',
    padding: '2px 8px',
    fontFamily: 'monospace',
    fontSize: '12px',
    marginRight: '6px',
    cursor: 'pointer',
    userSelect: 'all',
};

const PLACEHOLDERS = [
    { tag: '{{link_start}}', description: 'Begin van de link' },
    { tag: '{{link_end}}', description: 'Einde van de link' },
    { tag: '{{cookie_count}}', description: 'Aantal cookies' },
    { tag: '{{platform_count}}', description: 'Aantal partners' },
];

export const ConsentMessagePlaceholderHint = () => (
    <div style={placeholderHintStyle}>
        <strong>Beschikbare placeholders voor Consent Message:</strong><br />
        {PLACEHOLDERS.map(({ tag, description }) => (
            <span key={tag} style={{ display: 'inline-flex', alignItems: 'center', marginRight: '16px' }}>
                <span
                    style={badgeStyle}
                    title="Klik om te kopiëren"
                    onClick={() => navigator.clipboard.writeText(tag)}
                >
                    {tag}
                </span>
                <span style={{ fontSize: '12px', color: '#555' }}>{description}</span>
            </span>
        ))}
    </div>
);

const validateDomain = regex(/^[a-zA-Z0-9](?:[a-zA-Z0-9-.]{0,61}[a-zA-Z0-9])?\.[a-zA-Z]{2,}$/, 'Must be a valid domain. Do not add www or http prefix. Subdomains should be converted to main domain.');
const requiredDomain = [required(), validateDomain];

const consentDefaultValue = {
    cookie_consent_template: '/api/cookie-consent-templates/1e0d8604-4f14-4de6-81a6-f3833c401b5e',
    cookie_consent_language: '/api/cookie-consent-languages/4b1beb49-f51d-4ac2-989b-6c4cf4a9dabd',
    cookie_consent_position: '/api/cookie-consent-positions/07c5eb6d-c343-41d1-896f-1b0ae60a83eb',
    cookie_consent_same_site: '/api/cookie-consent-same-sites/08fc2129-d301-4b6a-a7bb-22a3f7a65897',
};

export const CookieConsentCreate = (props) => (

    <Create {...props}>
        <TabbedForm redirect="list" initialValues={consentDefaultValue}>
            <FormTab label="Settings">

                <TextInput source="name" label="Name" validate={required()} />
                <TextInput source="url" label="URL" validate={requiredDomain} />
                <BooleanInput source="active" label="Active" defaultValue={true} />
                <BooleanInput source="logging" label="Consent logging" defaultValue={true} />
                <BooleanInput source="more_cookie_information_enabled" label="Enable more cookie information" defaultValue={true} />
                <BooleanInput source="analytics_enabled" label="Enable Analytics cookies" defaultValue={true} />
                <BooleanInput source="functional_enabled" label="Enable Functional cookies" defaultValue={true} />
                <BooleanInput source="marketing_enabled" label="Enable Marketing cookies" defaultValue={true} />
                <BooleanInput source="analytics_default_checked" label="Analytics default checked" defaultValue={false} />
                <BooleanInput source="functional_default_checked" label="Functional default checked" defaultValue={false} />
                <BooleanInput source="marketing_default_checked" label="Marketing default checked" defaultValue={false} />
                <BooleanInput source="show_cookie_description" label="Show cookie description" defaultValue={false} />
                <BooleanInput source="backdrop_enabled" label="Backdrop enabled" defaultValue={true} />
                <BooleanInput source="reload_on_consent" label="Reload on consent" />
                <BooleanInput source="show_widget" label="Show widget" />

                <ReferenceInput label="Template" source="cookie_consent_template" reference="cookie-consent-templates" validate={required()}>
                    <SelectInput optionText="name" />
                </ReferenceInput>

                <ReferenceInput label="Language" source="cookie_consent_language" reference="cookie-consent-languages" validate={required()}>
                    <SelectInput optionText="name" />
                </ReferenceInput>

                <ReferenceInput label="Position" source="cookie_consent_position" reference="cookie-consent-positions" validate={required()}>
                    <SelectInput optionText="name" />
                </ReferenceInput>

                <ReferenceInput label="SameSite" source="cookie_consent_same_site" reference="cookie-consent-same-sites" validate={required()}>
                    <SelectInput optionText="name" />
                </ReferenceInput>

                <TextInput source="data_layer" label="Data layer name" validate={required()} defaultValue="dataLayer" />
                <TextInput multiline source="alternate_domains" label="Alternate url's" />

            </FormTab>

            <FormTab label="Consent mode">

                <BooleanInput source="google_consent_mode_enabled" label="Google Consent Mode" defaultValue={true} />
                <BooleanInput source="microsoft_consent_mode_enabled" label="Microsoft Consent Mode" defaultValue={false} />
                <BooleanInput source="enforce_gtag" label="Enforce gtag" defaultValue={false} />
                <BooleanInput source="default_security_storage_granted" label="Default security storage granted" defaultValue={true} />
                <BooleanInput source="default_personalization_storage_granted" label="Default personalization granted" defaultValue={false} />
                <BooleanInput source="default_preferences_storage_granted" label="Default preferences storage granted" defaultValue={false} />
                <BooleanInput source="default_analytics_storage_granted" label="Default analytics storage granted" defaultValue={false} />
                <BooleanInput source="default_ad_storage_granted" label="Default ad storage granted" defaultValue={false} />
                <BooleanInput source="default_ad_user_data_granted" label="Default ad user data granted" defaultValue={false} />
                <BooleanInput source="default_ad_personalization_granted" label="Default ad personalization granted" defaultValue={false} />

            </FormTab>

            <FormTab label="Layout">

                <ColorInput source="color" label="Color backdrop" defaultValue={"#000000"} />

                <ColorInput source="button1_color" label="Allow all button color" />
                <ColorInput source="button2_color" label="Cookie settings button color" />
                <ColorInput source="button3_color" label="Save settings button color" />
                <ColorInput source="button4_color" label="Reject button color" />
                <ColorInput source="pill_color" label="Pill color" />

                <BooleanInput source="hidden_horizontal_rule" label="Hide horizontal rule" defaultValue={true} />

                <TextInput source="font" label="Font" />

                <SelectInput source="title_transform" allowEmpty={true} choices={[
                    { id: 'none', name: 'None' },
                    { id: 'capitalize', name: 'Capitalize' },
                    { id: 'uppercase', name: 'Uppercase' },
                    { id: 'lowercase', name: 'Lowercase' },
                ]} />

                <NumberInput source="header_size" label="Header font size" step={1} />
                <NumberInput source="subheader_size" label="Subheader font size" step={1} />
                <NumberInput source="body_size" label="Body font size" step={1} />
                <NumberInput source="always_active_size" label="Always active font size" step={1} />
                <NumberInput source="consent_height" label="Consent height" step={1} />
                <TextInput multiline source="inline_css" label="Inline css" fullWidth={true} />

            </FormTab>

            <FormTab label="Descriptions">
                <TextInput source="consent_title" label="Consent title" validate={required()} defaultValue="Wij respecteren uw privacy" />
                <ConsentMessagePlaceholderHint />
                <RichTextInput {...props} source="consent_message" defaultValue="Wij en onze partners gebruiken technologie op onze site, zoals cookies om inhoud en advertenties te personaliseren, social media functies te bieden en ons websiteverkeer te analyseren. Klik hieronder om akkoord te gaan met ons privacy beleid. U kunt op elk moment van gedachten veranderen en uw instemmingskeuzes wijzigen door terug te keren naar deze site." />
                <TextInput source="preferences_title" label="Preferences Title" validate={required()} defaultValue="Cookie instellingen aanpassen" />
                <RichTextInput {...props} source="preferences_message" defaultValue="Deze website maakt gebruik van strikt noodzakelijke cookies, die nodig zijn om deze site zo goed mogelijk te laten functioneren. Hieronder kan je aangeven welke andere soorten cookies je wilt accepteren." />
                <TextInput source="strictly_necessary_cookies" label="Strictly necessary cookies Title" validate={required()} defaultValue="Strikt noodzakelijke en statistieken cookies" />
                <RichTextInput {...props} source="strictly_necessary_cookies_description" defaultValue="Deze cookies zijn noodzakelijk voor het functioneren van de website. Deze cookies zijn dan ook vereist." />
                <TextInput source="analytics_cookies" label="Analytics Cookies Title" validate={required()} defaultValue="Statistieken cookies" />
                <RichTextInput {...props} source="analytics_cookies_description"defaultValue="Deze cookies worden gebruikt voor analyse doeleinden om de website te verbeteren." />
                <TextInput source="functional_cookies" label="Functional cookies title" validate={required()} defaultValue="Functionele cookies" />
                <RichTextInput {...props} source="functional_cookies_description" defaultValue="Deze puur functionele cookies worden b.v. gebruikt om persoonlijke voorkeuren op te slaan." />
                <TextInput source="marketing_cookies" label="Marketing cookies Title" validate={required()} defaultValue="Advertentie cookies" />
                <RichTextInput {...props} source="marketing_cookies_description" defaultValue="Deze cookies worden gebruikt om bij te houden welke advertenties je al hebt gezien en hoe vaak." />
            </FormTab>
            <FormTab label="More cookie information">

                <TextInput source="cookie_table_name_header" label="Cookie table name header" validate={required()} defaultValue="Naam" />
                <TextInput source="cookie_table_category_header" label="Cookie table category header" validate={required()} defaultValue="Categorie" />
                <TextInput source="cookie_table_platform_header" label="Cookie table platform header" validate={required()} defaultValue="Platform" />
                <TextInput source="cookie_table_period_header" label="Cookie table period header" validate={required()} defaultValue="Periode" />
                <TextInput source="cookie_table_purpose_header" label="Cookie table purpose header" validate={required()} defaultValue="Doel" />
                <TextInput source="cookie_table_unknown" label="Cookie table unknown" validate={required()} defaultValue="Onbekend" />
                <TextInput source="cookie_table_updated" label="Cookie table updated" validate={required()} defaultValue="Laatst bijgewerkt" />

                <TextInput source="more_cookie_information" label="Title" validate={required()} defaultValue="Wat zijn cookies?" />
                <RichTextInput {...props} source="more_cookie_information_description" defaultValue="<p>Cookies zijn kleine tekstbestanden die door websites kunnen worden gebruikt om gebruikerservaringen te monitoren en te optimaliseren. Cookies worden opgeslagen op uw computer en kunnen door ons of onze partners worden uitgelezen voor verschillende doeleinden.</p><p>Volgens de AVG wetgeving en ePrivacy Verordening mogen wij cookies plaatsen als ze strikt noodzakelijk zijn voor het kunnen gebruiken van de website, of wanneer ze voor analytische doeleinden gebruikt worden en geen of geringe impact hebben op de privacy van websitebezoekers. Voor het gebruik van andere soorten cookies hebben we uw toestemming nodig.</p><p>Deze website maakt gebruik van verschillende soorten cookies. Sommige cookies worden geplaatst door diensten van derden die op sommige van onze pagina's worden weergegeven. Hieronder vind je een overzicht van alle cookies die geplaatst kunnen worden, waarvoor deze gebruikt worden en wie de eigenaar is.</p><h3>Functionele cookies</h3><p>Functionele cookies zijn nodig om de website correct te laten functioneren. Deze cookies zijn bijvoorbeeld nodig voor winkelmandjes, land- en taalvoorkeuren, privacy voorkeuren, etc. Het gaat hierbij zowel om sessie als permanente cookies. Functionele cookies worden bijna altijd door het domein van de bezochte website geplaatst. Uitzonderingen zijn bijvoorbeeld cookies van derde partijen voor het registeren van privacy voorkeuren of om de website te beveiligen tegen spam of ddos aanvallen.</p><h3>Analytics cookies</h3>                 <p>Analytics cookies worden gebruikt om data te verzamelen over het gebruik van websites, apps en andere digitale media. Op basis van deze data worden websites, apps en andere digitale media geoptimaliseerd en gebruiksvriendelijker gemaakt. De data is anoniem en bevat bijvoorbeeld informatie over bezochte pagina's van de website en hoe je op de website bent gekomen. Analytics cookies worden geplaatst door de website die je bezoekt of domeinen van derden.</p><h3>Marketing cookies</h3><p>Marketing cookies verzamelen informatie over gebruik van websites, gebruikte zoekwoorden en hoe bezoekers op een website zijn gekomen. Deze data wordt gebruikt voor rapportages, om websites beter te maken en om een beter en relevanter aanbod te doen aan gebruikers op zowel de eigen website als die van partners (adverteren, retargeting, etc.). Deze cookies kunnen worden geplaatst door zowel de bezochte websites als domeinen van derden.</p><h3>Social cookies</h3><p>Social cookies worden gebruikt om bepaalde functionaliteiten van derden te integreren binnen websites, zoals bijvoorbeeld Youtube video's en social sharing functies. Dit soort cookies kunnen worden geplaatst door domeinen van derden, waaronder maar niet uitsluitend: Youtube.com, Facebook.com, Instagram.com, Pinterest.com, Linkedin.com, Snapchat.com en Tumblr.com.</p><h3>Overige cookies</h3><p>Van cookies die in de categorie Overig vallen is nog niet bekend wat ze precies doen. Het gaat dan altijd om nieuwe cookies van derde partijen waarvan we samen met deze partijen nog aan het bepalen zijn in welke categorie de cookie horen te vallen.</p>" />
            </FormTab>

            <FormTab label="Buttons">
                <TextInput source="manage_cookie_preferences" label="Manage cookie preferences" validate={required()} defaultValue="Uw cookie instellingen" />
                <TextInput source="accept_cookies" label="Accept cookies" validate={required()} defaultValue="Cookies accepteren" />
                <TextInput source="cookies_settings" label="Cookie settings" validate={required()} defaultValue="Cookie instellingen" />
                <TextInput source="allow_all" label="Allow all" validate={required()} defaultValue="Alles accepteren" />
                <TextInput source="reject" label="Reject" validate={required()} defaultValue="Afwijzen" />
                <TextInput source="save_settings" label="Save settings" validate={required()} defaultValue="Instellingen opslaan" />
                <TextInput source="always_active" label="Always active" validate={required()} defaultValue="Altijd actief" />
            </FormTab>

        </TabbedForm>
    </Create>
);